<template>
  <form class="needs-validation mc-form mc-form--address" @submit.prevent="submitForm">
    <b-row class="mc-form--address-search mb-2">
      <b-col md="10">
        <b-form-input
          :id="`search-address-${identifier}`"
          :placeholder="$t('master.form.address.searchLocation')"
          v-model="searchLocation"
          trim
          autocomplete="on"
          @change="setLocation"
          :disabled="searchInputDisabled"
        ></b-form-input>
      </b-col>
      <b-col md="2">
        <b-button class="mc-btn--block" variant="primary" @click="getLocation" :disabled="searchInputDisabled">
          {{ $t('global.search') }}
        </b-button>
      </b-col>
      <b-col md="12">
        <div :style="{ position: 'relative', pointerEvents: searchInputDisabled ? 'none' : 'all' }">
          <div class="disabled-map-overlay" v-if="searchInputDisabled"></div>
          <GmapMap
            id="map"
            :ref="identifier"
            :center="$store.state.map.center"
            :zoom="parseFloat($store.state.map.zoom)"
            class="mc-map-address mt-2"
          ></GmapMap>
        </div>
      </b-col>
    </b-row>
  </form>
</template>
<script>
import { gmapApi } from 'vue2-google-maps'
import { Helper } from '@/mixin/helper'
export default {
  mixins: [Helper],
  props: {
    identifier: {
      type: String,
      default: 'MapAddress'
    },
    location: {
      type: Object
    },
    searchInputDisabled: {
      type: Boolean
    }
  },
  data() {
    return {
      inputElement: null,
      searchLocation: null,
      map_radio: 'circle',
      map: null,
      places: [],
      isEdit: false,
      circle: null,
      form: {
        latitude: '',
        longitude: '',
        radius: 100,
        circle_data: [],
        latLong: '',
        province: '',
        city: ''
      }
    }
  },
  computed: {
    google: gmapApi,
    fullLocation() {
      let province = ''
      let city = ''

      if (this.places.length) {
        const data = this.places[0]
        const { address_components: addressComponents } = data
        addressComponents.forEach(val => {
          if (val.types[0] === 'administrative_area_level_1') province = val.long_name
          if (val.types[0] === 'administrative_area_level_2') city = val.long_name
        })
      }
      return {
        latitude: this.form.latitude,
        longitude: this.form.longitude,
        province,
        city
      }
    }
  },
  watch: {
    form: {
      handler: function(val) {
        const fullLocation = {...this.fullLocation}
        fullLocation.latitude = val.latitude
        fullLocation.longitude = val.longitude

        this.$emit('update:location', fullLocation)
      },
      deep: true
    },
  },
  async mounted() {
    const self = this
    await this.$refs[this.identifier].$mapPromise.then((map) => {
      self.map = map
    })

    setTimeout(() => {
      this.inputElement = document.getElementById(`search-address-${this.identifier}`)
      const searchBox = new this.google.maps.places.SearchBox(this.inputElement)

      // Bias the SearchBox results towards current map's viewport.
      this.map.addListener('bounds_changed', () => {
        searchBox.setBounds(this.map.getBounds())
      })

      // Listen for the event fired when the user selects a prediction and retrieve
      // more details for that place.
      searchBox.addListener('places_changed', () => {
        this.isEdit = false
        const places = searchBox.getPlaces()
        this.places = places
        if (places.length == 0) {
          return
        }

        if (this.map_radio === 'circle') {
          this.initMapCircle(places)
        }

        // Retain google map input value since whenever we set the input to be disabled,
        // it will rollback the google input value to user input, so there's inconsistency.
        this.searchLocation = this.inputElement.value

        this.$emit('update:location', this.fullLocation)
      })

      if (this.location) {
        this.setLatLng(this.location.latitude, this.location.longitude)
      }
    }, 200)
  },
  methods: {
    submitForm() {
      this.$v.$touch()
    },
    setLocation() {
      setTimeout(() => {
        this.getLocation()
      }, 1200)
    },
    async getLocation() {
      if (this.map_radio === 'circle') {
        if (this.circle == null) return

        this.form.latitude = this.circle.center.lat()
        this.form.longitude = this.circle.center.lng()
        this.form.radius = this.circle.getRadius()

        this.form.circle_data = [this.form.latitude, this.form.longitude]
        this.form.latLong = '(' + this.form.latitude + ', ' + this.form.longitude + ')'
      }
    },
    setLatLng(latitude, longitude) {
      if (this.circle != null) {
        this.circle.setMap(null)
        this.circle = null
      }

      this.circle = new this.google.maps.Circle({
        strokeColor: '#0D4491',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#1C74DA',
        fillOpacity: 0.35,
        map: this.map,
        radius: parseInt(this.form.radius),
        editable: true,
        draggable: true,
      })
      var circle = this.circle

      this.circle.setMap(null)
      this.circle.setMap(this.map)

      this.circle.setCenter({
        lat: parseFloat(latitude),
        lng: parseFloat(longitude),
      })      

      this.map.fitBounds(this.circle.getBounds())

      this.google.maps.event.addListener(circle, 'center_changed', () => {
        this.updateCircleCoordsState(circle)
      })

      this.google.maps.event.addListener(circle, 'radius_changed', () => {
        this.updateCircleCoordsState(circle)
      })
    },
    initMapCircle(places) {
      if (this.circle != null) {
        this.circle.setMap(null)
        this.circle = null
      }

      this.circle = new this.google.maps.Circle({
        strokeColor: '#0D4491',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#1C74DA',
        fillOpacity: 0.35,
        map: this.map,
        radius: parseInt(this.form.radius),
        editable: true,
        draggable: true,
      })
      var circle = this.circle

      this.circle.setMap(null)
      this.circle.setMap(this.map)

      if (places === undefined) {
        this.circle.setCenter({
          lat: parseFloat(this.form.latitude),
          lng: parseFloat(this.form.longitude),
        })
      } else {
        this.circle.setCenter(places[0].geometry.location)
      }

      this.map.fitBounds(this.circle.getBounds())

      this.google.maps.event.addListener(circle, 'center_changed', () => {
        this.updateCircleCoordsState(circle)
      })

      this.google.maps.event.addListener(circle, 'radius_changed', () => {
        this.updateCircleCoordsState(circle)
      })
    },
    updateCircleCoordsState(circle) {
      this.form.latitude = circle.center.lat()
      this.form.longitude = circle.center.lng()
      this.form.radius = circle.getRadius()

      this.form.circle_data = [this.form.latitude, this.form.longitude]
      this.form.latLong = '(' + this.form.latitude + ', ' + this.form.longitude + ')'
    }
  }
}
</script>
<style lang="scss" scoepd>
.disabled-map-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
</style>